import React, { forwardRef } from 'react';
import { UIElementProps } from 'types/prop-types';

type ButtonProps = UIElementProps & {
  children: React.ReactNode;
  onClick?: (e: any) => void;
  href?: string;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  tag?: 'button' | 'a' | 'input';
  style?: React.CSSProperties;
  arialabel?: string;
  color?:
    | 'clear'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'
    | 'outline'
    | 'outlinePurple'
    | 'featured'
    | 'pink';
  [key: string]: any;
};

const buttonColor: any = {
  clear: '',
  primary: 'bg-purple text-white',
  secondary: 'bg-blue-light text-blue-dark',
  danger: 'bg-red-600 text-white ring-2 ring-white',
  success: 'bg-green-600 text-white ring-2 ring-white',
  outline: 'bg-transparent text-yellow ring-2 ring-yellow',
  outlinePurple: 'bg-transparent text-white ring-2 ring-purple',
  featured: 'bg-yellow text-blue-dark',
  pink: 'bg-[#E46382] text-white',
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(props, ref) {
  const { children, className, color, arialabel, 'aria-label': ariaLabel, ...rest } = props;

  return (
    <button
      ref={ref}
      {...rest}
      className={`${
        buttonColor[color || 'primary']
      } hover:ring hover:ring-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow rounded-md shadow-xl font-bold px-4 ${className || ''}`}
      aria-label={arialabel ?? ariaLabel}
    >
      <div className="p-1 leading-tight">{children}</div>
    </button>
  );
});

export default Button;
